import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import { MessageBox } from '../../components/MessageBox';
import { useMessageBox } from '../../context/MessageBox';
import api from '../../services/api';
import { handleErrorRequest } from '../../utils/errorsValidation';
import ApproveConclusion from './ApproveConclusion';
import KnowAboutConclusion from './KnowAboutConclusion';
import RefuseConclusion from './RefuseConclusion';
import * as S from './styles';

const statusConclusion = {
  approved: 'Aprovada',
  refused: 'Recusada',
  talkAbout: 'Questionada',
};

const titleConclusion = {
  Aprovada: 'Aprovação da proposta',
  Recusada: 'Recusa da proposta',
  Questionada: 'Fale Conosco',
};

export function ConclusionOperation() {
  const [conclusionData, setConclusionData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const { setMessageData } = useMessageBox();

  const [isLoading, setIsLoading] = useState(true);

  const saveForm = async () => {
    setIsLoading(true);
    const formData = {
      ancoraId: conclusionData?.ancoraId,
      antecipacaoCodigoAutenticacaoId: conclusionData?.antecipacaoCodigoAutenticacaoId,
      antecipacaoId: conclusionData?.antecipacaoId,
      antecipacaoMotivoRecusaId: 0,
      codigoAutenticacaoDigitado: '0000',
      conclusao: 'ContatoSolicitado',
      dataAtualizacao: conclusionData?.dataAtualizacao,
      fornecedorContaBancariaId: conclusionData?.fornecedorContaBancariaId,
      fornecedoresContasBancarias: {
        agencia: conclusionData?.agencia || '',
        ancoraId: conclusionData?.ancoraId,
        bancoId: Number(conclusionData?.fornecedorContaBancariaId),
        cnpjCpf: conclusionData.gruposFornecedores?.raizCnpjCpf,
        conta: conclusionData?.conta || '',
        fornecedorId: conclusionData?.fornecedorId,
        status: 'Ativo',
      },
      fornecedorId: conclusionData?.fornecedorId,
      respostaDoFornecedor: '',
      origemAprovacao: conclusionData.origemAprovacao
    };

    try {
      const response = await api.put('OperacoesAntecipacoes/ConcluirAntecipacao', formData);
      setMessageData(response.data?.complemento?.mensagensBox);
      if (response.data === []) {
        setNoData(true);
      }
      if (response.data.status !== 'Inconsistencia') {
        setConclusionData(response.data?.resposta);
        setResponseMessage(response.data?.resposta?.mensagem);
      } else {
        handleErrorRequest(response);
        setNoData(true);
      }
    } catch (error) {
      toast.error(error.response);
      setMessageData(error.response.data?.complemento?.mensagensBox);
    }
    setIsLoading(false);
  };

  const fetchConclusion = async () => {
    setIsLoading(true);
    const conclusionParam = sessionStorage.getItem('conclusionParam');
    try {
      const response = await api.get(
        `OperacoesAntecipacoes/ConsultarParametrosLinkPaginaConclusao?parametros=${conclusionParam}`,
      );
      setMessageData(response.data?.complemento?.mensagensBox);
      if (response.data == []) {
        setNoData(true);
      }
      if (response.data.status !== 'Inconsistencia') {
        setConclusionData(response.data?.resposta);
      } else {
        handleErrorRequest(response);
        setNoData(true);
      }
    } catch (e) {
      toast.error(e.response);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchConclusion();
    document.title = 'Mesa de Antecipação';
    const link = document.querySelector('link[rel="icon"]');
    link.href = '/app/PaginaConclusao.ico';
  }, []);

  if (isLoading) {
    return (
      <S.LoaderContainer>
        <Loading />
      </S.LoaderContainer>
    );
  }

  if (noData) {
    return (
      <S.LoaderContainer>
        <h1>Servidor em manutenção</h1>
        <h2>Tente novamente mais tarde</h2>
      </S.LoaderContainer>
    );
  }

  return (
    <S.Container>
      <S.Header>
        <img src={conclusionData?.logotipoLink} alt="" />
      </S.Header>

      {responseMessage ? (
        <S.InfoContainer>
          <S.ResponseMessage dangerouslySetInnerHTML={{ __html: responseMessage }} />
        </S.InfoContainer>
      ) : (
        <>
          <S.InfoContainer>
            {conclusionData?.tituloBoxConfirmacao && (
              <S.TableTitleHeader>
                <h1>{conclusionData?.tituloBoxConfirmacao}</h1>
              </S.TableTitleHeader>
            )}
            <div
              className="message-html"
              style={{ padding: '5px 10px' }}
              dangerouslySetInnerHTML={{ __html: conclusionData?.mensagem }}
            ></div>
          </S.InfoContainer>
          
          {conclusionData?.conclusao === statusConclusion.approved && (
            <ApproveConclusion data={conclusionData} setResponseMessage={setResponseMessage} />
          )}
          {conclusionData?.conclusao === statusConclusion.refused && (
            <RefuseConclusion data={conclusionData} setResponseMessage={setResponseMessage} />
          )}
          {conclusionData?.conclusao === statusConclusion.talkAbout && (
            <KnowAboutConclusion data={conclusionData} setResponseMessage={setResponseMessage} />
          )}

          {conclusionData?.botaoSolicitarContato && (
            <S.ConfirmationBox>
              <S.ActionButton variant="contained" onClick={() => saveForm()}>
                Solicitar contato da mesa de crédito
              </S.ActionButton>
            </S.ConfirmationBox>
          )}
        </>
      )}
    </S.Container>
  );
}
